var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.954 10.5148C13.5427 11.4874 12.8995 12.3444 12.0805 13.011C11.2615 13.6775 10.2916 14.1333 9.25578 14.3385C8.21993 14.5436 7.14959 14.4919 6.13834 14.1878C5.12709 13.8838 4.20572 13.3366 3.45478 12.5942C2.70385 11.8518 2.14621 10.9367 1.83062 9.92903C1.51502 8.92132 1.45109 7.85164 1.64441 6.81351C1.83773 5.77538 2.2824 4.80042 2.93957 3.97385C3.59673 3.14728 4.44637 2.49428 5.41421 2.07193",
    stroke: "inherit",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4646 8C14.4646 7.15105 14.2974 6.31041 13.9726 5.52608C13.6477 4.74176 13.1715 4.0291 12.5712 3.4288C11.9709 2.8285 11.2582 2.35232 10.4739 2.02744C9.68959 1.70256 8.84895 1.53535 8 1.53535V8H14.4646Z",
    stroke: "inherit",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.d2f2c53e.svg";
export { ForwardRef as ReactComponent };